import React from 'react';
import { Toolbar } from '@mui/material';
import { styled } from '@mui/material/styles';

export const FOOTER_HEIGHT = 65;
export const MOBILE_FOOTER_HEIGHT = 155;

const StyledContainer = styled('div')(({ theme: { breakpoints, mixins, palette } }: any) => ({
  backgroundColor: palette.grey[50],
  display: 'flex',
  flexDirection: 'column',
  minHeight: `calc(100vh - ${mixins.toolbar['@media (min-width:600px)'].minHeight}px - ${FOOTER_HEIGHT}px)`,
  [breakpoints.down('xs')]: {
    minHeight: `calc(100vh - ${mixins.toolbar.minHeight}px - ${MOBILE_FOOTER_HEIGHT}px)`,
  },
}));

const StyledToolbar = styled(Toolbar)(({ theme: { shadows, spacing } }: any) => ({
  backgroundColor: 'white',
  boxShadow: shadows[1],
  paddingTop: spacing(2),
  paddingBottom: spacing(2),
}));

function SubNavBar({ navbar, children }: any) {
  return (
    <StyledContainer>
      <StyledToolbar disableGutters>{navbar}</StyledToolbar>
      {children}
    </StyledContainer>
  );
}

export default SubNavBar;
